import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';

import { makeStyles } from '@material-ui/core/styles';

import './Avatar.css';
import { MenuItem, Divider } from '@material-ui/core';

const ItemPicker = (props: any) => {
  const { menuListHeader, headerDisabled, onHeaderClick, id } = props;
  return (
    <div id={id}>
      {id === 'navbar-logout' ? '' : <Divider />}
      {menuListHeader && (
        <MenuItem id="item" disabled={headerDisabled} onClick={() => onHeaderClick()}>
          {menuListHeader}
        </MenuItem>
      )}
      {/* {menuListItem && menuListItem.length > 0 && menuListItem.map((item: any) => (
          <MenuItem
            id={`${id}-${item.label}`}
            disabled={item.disabled}
            onClick={() => item.onItemClick(item.clickedItem)}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;
            {item.label}
          </MenuItem>
        )
        )} */}
    </div>
  );
};

const UserNameRender = (props: any) => {
  const { children, onClick } = props;
  return (
    <div onClick={onClick} className="usernamecontainerstyle">
      {children}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  icon: {
    width: 20,
    flexGrow: 1,
    margin: 7,
    padding: 0,
    color: 'white'
  },
  userIcon: {
    width: 24,
    height: 24,
    backgroundColor: '#ffff',
    color: 'black',
    fontSize: 12
  }
}));

const getAvatarString = (nameStr: string) => {
  // check for @
  if (nameStr.indexOf('@') > -1 || nameStr.indexOf(' ') < 0) {
    return nameStr
      .split('@')[0]
      .substring(0, 2)
      .toUpperCase();
  }
  const y = nameStr.split(' ').map(e => e.charAt(0));
  return `${y[0].toUpperCase()}${y[y.length - 1].toUpperCase()}`;
};
const UserName = (props: any) => {
  const classes = useStyles();
  const { imageSrc, username, onClick } = props;
  if (!imageSrc && !username) {
    return null;
  }
  return (
    <IconButton onClick={onClick} className={classes.icon}>
      <Avatar alt="Avatar Image" src={imageSrc} className={classes.userIcon}>
        {' '}
        {username && getAvatarString(username)}
      </Avatar>
    </IconButton>
  );
};

const UserNameContainer = (props: any) => {
  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const handleUserMenu = (event: any) => setAnchorEl(event.currentTarget);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { menuId, classes, style, menuItems, children, paperProps, closeMenuAfterClick } = props;

  const menuStyle = style ? { ...style.menu } : {};
  return (
    <UserNameRender style={style} classes={classes}>
      <UserName onClick={handleUserMenu} {...props} />
      {menuItems && (
        <Menu
          style={menuStyle}
          id={menuId}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={paperProps}
        >
          {menuItems.map((item: any, index: number) => (
            <ItemPicker
              onClose={handleClose}
              closeMenuAfterClick={closeMenuAfterClick}
              menuListHeader={item.menuListHeader}
              headerDisabled={item.headerDisabled}
              onHeaderClick={item.onHeaderClick}
              menuListItem={item.menuListItem}
              id={item.id}
              index={index}
            />
          ))}
        </Menu>
      )}
      {children}
    </UserNameRender>
  );
};

export default UserNameContainer;
